import { siteApiSlice } from "../../app/siteApiSlice";

export enum StimulusMaterialType {
	File = "File",
	Url = "Url",
}

export interface StimulusMaterialViewModel {
	id: number;
	url: string;
	label: string;
	stimulusMaterialType: StimulusMaterialType;
	fileContentType: string;
	signLanguageVideoUrl: string;
	editMode: boolean;
}

export interface StimulusMaterialEditModel {
	id: number;
	promptId: number;
	label: string;
	fileName?: string;
	stimulusMaterialType: StimulusMaterialType;
	url: string;
}

export interface StimulusMaterialSaveModel {
	editModel: StimulusMaterialEditModel;
	files?: FileList;
	editing?: boolean;
}

export interface StimulusMaterialFetchModel {
	stimulusMaterialId: number;
	promptId: number;
}

export const promptApiSlice = siteApiSlice
	.enhanceEndpoints({
		addTagTypes: ["StimulusMaterial"],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getStimulusMaterial: build.query<StimulusMaterialViewModel[], number>({
				query: (promptId) => ({
					url: `/Prompt/GetStimulusMaterial`,
					params: { promptId },
				}),
				providesTags: ["StimulusMaterial"],
			}),
			editStimulusMaterial: build.query<
				StimulusMaterialEditModel,
				StimulusMaterialFetchModel
			>({
				query: (payload) => {
					const { stimulusMaterialId, promptId } = payload;
					return {
						url: `/Prompt/EditStimulusMaterial`,
						params: { stimulusMaterialId, promptId },
					};
				},
				providesTags: ["StimulusMaterial"],
			}),
			addEditStimulusMaterial: build.mutation<void, StimulusMaterialSaveModel>({
				query: (payload) => {
					const formData = new FormData();
					if (payload.files) {
						formData.append("attachment", payload.files[0]);
					}
					formData.append("editModel", JSON.stringify(payload.editModel));

					if (payload.editing) {
						formData.append("editing", payload.editing.toString());
					}

					return {
						url: `/Prompt/AddEditStimulusMaterialSpa`,
						method: "POST",
						body: formData,
					};
				},
				invalidatesTags: ["Prompts", "StimulusMaterial"],
			}),
			deleteStimulusMaterial: build.mutation<void, StimulusMaterialFetchModel>({
				query: (payload) => {
					return {
						url: `/Prompt/DeleteStimulusMaterial`,
						method: "POST",
						body: payload,
					};
				},
				invalidatesTags: ["Prompts", "StimulusMaterial"],
			}),
		}),
	});

export const {
	useGetStimulusMaterialQuery,
	useLazyEditStimulusMaterialQuery,
	useAddEditStimulusMaterialMutation,
	useDeleteStimulusMaterialMutation,
} = promptApiSlice;
